//Uncomment this line on creating a translation file
import { editorLocalization, defaultStrings } from "../editorLocalization";

export var tgStrings = {
  // strings for survey templates
  survey: {
    edit: "Тағйир додан",
    externalHelpLink: "Ёд гирифтани ташкил кардани саволномаҳо",
    externalHelpLinkUrl:
      "Https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
    dropQuestion: "Илтимос, элементи даркориро аз бастаи чап кашида биёред.",
    copy: "Нусхабардорӣ кардан",
    addToToolbox: "Илова кардан ба асбобҳо",
    deletePanel: "Нест кардани баста",
    deleteQuestion: "Нест кардани савол",
    convertTo: "Тағйир додани шакл ба",
    drag: "Кашидани элемент"
  },
  // questionTypes
  qt: {
    default: "Бо нобаёнӣ",
    checkbox: "Интихоби бисёр",
    comment: "Шарҳ",
    imagepicker: "Интихоби сурат",
    dropdown: "Рӯйхати таркишӣ",
    file: "Боркунии файлҳо",
    HTML: "HTML",
    matrix: "Матриса (интихоби танҳо)",
    matrixdropdown: "Матриса (интихоби бисёр)",
    matrixdynamic: "Матриса (сатрҳои динамикӣ)",
    multipletext: "Матнҳои бисёр",
    panel: "Баста (барои гурӯҳи саволҳо)",
    paneldynamic: "Баста (бастаҳои динамикӣ)",
    radiogroup: "Интихоби танҳо",
    rating: "Рейтинг (миқёс)",
    text: "Воридкунии матнӣ",
    boolean: "Қиммати булӣ",
    expression: "Ифода (танҳо барои хондан)",
    flowPanel: "Бастаи селоба"
  },
  // Strings in Editor
  ed: {
    defaultLocale: "Бо нобаёнӣ ({0})",
    survey: "Саволнома",
    settings: "Танзимоти саволнома",
    opjectPropertiesHeader: "Иловагӣ",
    showObjectProperties: "Нишон додани хусусиятҳои объект",
    hideObjectProperties: "Пинҳон додани хусусиятҳои объект",
    editSurvey: "Иваз намудани саволнома",
    addNewPage: "Сохтани саҳифаи нав",
    moveRight: "Ба рост тоб додан",
    moveLeft: "Ба чап тоб додан",
    deletePage: "Нест кардани саҳифа",
    editPage: "Тағйир додани саҳифа",
    edit: "Тағйир додан",
    newPageName: "саҳифа",
    newQuestionName: "савол",
    newPanelName: "баста",
    newTextItemName: "матн",
    testSurvey: "Санҷиши саволнома",
    testSurveyAgain: "Боз як бор санҷиш гузаронидан",
    testSurveyWidth: "Дарозии саволнома:",
    logic: "Мантиқи саволнома",
    embedSurvey: "Сабти саволнома",
    translation: "Тарҷума",
    saveSurvey: "Сабти саволнома",
    designer: "Дида баромадани конструктор",
    jsonEditor: "Тағйиркунаки JSON",
    undo: "Бекор кардан",
    redo: "Такрор",
    options: "Танзимотҳо",
    generateValidJSON: "Сохтани JSON-и дуруст",
    generateReadableJSON: "Сохтани JSON-и мехондагӣ",
    toolbox: "Бастаи асбобҳо",
    toolboxGeneralCategory: "Умумӣ",
    delSelObject: "Нест кардани объекти интихобшуда",
    editSelObject: "Тағйир додани объекти интихобшуда",
    correctJSON: "Илтимос, JSON-ро дуруст кунед.",
    surveyResults: "Натиҷаи ташхис:",
    surveyResultsTable: "Ҳамчун ҷадвал",
    surveyResultsJson: "Ҳамчун JSON",
    resultsTitle: "Сарлавҳаи савол",
    resultsName: "Мақсади савол",
    resultsValue: "Қиммати ҷавоб",
    resultsDisplayValue: "Қиммати нишондода",
    modified: "Тағйирдодашуда",
    saving: "Сабт",
    saved: "Сабтшуда",
    saveError: "Хатогӣ! Қиммати тағйиркунак сабт нашудааст.",
    translationAddLanguage: "Интихоби забон барои тарҷума",
    translationShowAllStrings: "Нишон додани ҳамаи сатрҳо",
    translationShowAllPages: "Нишон додани ҳамаи саҳифаҳо",
    translationNoStrings: "Сатрҳо барои тарҷума вуҷуд надоранд. Илтимос, филтрро тағйир диҳед.",
    translationExportToSCVButton: "Экспорт ба CSV",
    translationImportFromSCVButton: "Импорт аз CSV",
    translationMergeLocaleWithDefault: "Якҷоя кардани {0} бо локали нобаёнӣ",
    bold: "Ғавс",
    italic: "Қаҷ",
    underline: "Зерхат",
    fpAddQuestion: "Иловаи савол...",
    completedHtmlOnConditionItemText: "Нишон додан, агар:",
    lg: {
      //Logic tab strings
      page_visibilityName: "Намоиши саҳифа",
      panel_visibilityName: "Намоиши баста",
      panel_enableName: "Баста гирон/куштагӣ",
      question_visibilityName: "Намоиши савол",
      question_enableName: "Савол гирон/куштагӣ",
      question_requireName: "Савол ихтиёрӣ аст",
      trigger_completeName: "Назарсанҷӣ тамом шуд",
      trigger_setvalueName: "Сабти қиммати савол",
      trigger_copyvalueName: "Нусхабардорӣ кардани қиммати савол",
      trigger_skipName: "Гузаштан ба савол",
      trigger_runExpressionName: "Иҷро кардани ифодаи истифодабаранда",
      completedHtmlOnConditionName: "Матни истифодабаранда 'Саҳифаи ташаккурӣ'",

      page_visibilityDescription:
        "Саҳифаро намоён кардан, агар ифодаи мантиқӣ 'true' баргардонад. Вагарна онро нонамоён кардан.",
      panel_visibilityDescription:
        "Бастаро намоён кардан, агар ифодаи мантиқӣ 'true' баргардонад. Вагарна онро нонамоён кардан.",
      panel_enableDescription:
        "Бастаро ва ҳамаи элементҳои дохилии онро намоён кардан, агар ифодаи мантиқӣ 'true' баргардонад. Вагарна онро нонамоён кардан.",
      question_visibilityDescription:
        "Саволро намоён кардан, агар ифодаи мантиқӣ 'true' баргардонад. Вагарна онро нонамоён кардан.",
      question_enableDescription:
        "Саволро гирон кардан, агар ифодаи мантиқӣ 'true' баргардонад. Вагарна онро нонамоён кардан.",
      question_requireDescription:
        "Савол ҳатмӣ мешавад, вақте ки ифодаи мантиқӣ 'true' баргардонад.",
      trigger_completeDescription:
        "Вақте, ки ифодаи мантиқӣ 'true' баргардонад, он вақт ӯ ҳамчун тамом шуда ҳисобида мешавад ва истифодабар саҳифаи 'Саҳифаи ташаккурӣ'-ро мебинад.",
      trigger_setvalueDescription:
        "Вақте, ки қиммати саволҳо, ки дар ифодаи мантиқӣ истифода мешавад, тағйир мешаванд ва ифодаи мантиқӣ 'true' бармегардонад, он гоҳ ба саволи интихобшуда қиммат сабт мешавад.",
      trigger_copyvalueDescription:
        "Вақте, ки қимматҳои саволҳо, ки дар ифодаи мантиқӣ истифода мешаванд, тағйир меёбанд ва ифода қиммати 'true' бармегардонад, он гоҳ як қиммати саволи интихобшуда ба дигар савол нусхабардорӣ карда мешавад.",
      trigger_skipDescription:
        "Вақте, ки ифодаи мантиқӣ 'true' бармегардонад, он гоҳ саволнома ба саволи интихобшуда равона мешавад.",
      trigger_runExpressionDescription:
        "Вақте, ки ифодаи мантиқӣ 'true' бармегардонад, он гоҳ ифодаи истифодабар иҷро мешавад. Шумо, бо хоҳиш, метавонед натиҷаи ин ифодаро ба саволи интихобшуда бахшед.",
      completedHtmlOnConditionDescription:
        "Агар ифодаи мантиқӣ 'true' баргардонад, он гоҳ матн бо нобаёнӣ барои 'саҳифаи ташаккурӣ' тағйир мешавад ба ишорашуда.",

      itemExpressionText: "Вақте, ки ифода: '{0}' бармегардонад 'true':", //{0} - the expression
      page_visibilityText: "Саҳифаи {0}-ро намоён кардан ", //{0} page name
      panel_visibilityText: "Бастаи {0}-ро намоён кардан", //{0} panel name
      panel_enableText: "Бастаи {0}-ро гирон кардан", //{0} panel name
      question_visibilityText: "Саволи {0}-ро намоён кардан", //{0} question name
      question_enableText: "Саволи {0}-ро намоён кардан", //{0} question name
      question_requireText: "Саволи {0}-ро ҳатмӣ кардан", //{0} question name
      trigger_completeText: "Саволнома ҳамчун анҷомшуда тағйир меёбад",
      trigger_setvalueText: "Ба саволи {0} қиммати {1}-ро сабт кардан", //{0} question name, {1} setValue
      trigger_copyvalueText: "Нусхабардорӣ кардан ба саволи {0} қиммат аз саволи {1}", //{0} and {1} question names
      trigger_skipText: "Саволнома мегузарад ба саволи {0}", //{0} question name
      trigger_runExpressionText1: "Иҷро кардани ифодаи: '{0}'", //{0} the expression
      trigger_runExpressionText2: "ва натиҷаи онро ба саволи {0} гузоштан", //{0} question name
      completedHtmlOnConditionText:
        "Нишон додани матни истифодабар дар 'Саҳифаи ташаккурӣ'",

      expressionEditorTitle: "Танзимоти мантиқи ифода",

      deleteOperation: "Нест кардани амалиёт",
      addNewOperation: "Илова кардани амалиёти(ҳои) нав",

      expressionInvalid:
        "Ифодаи мантиқӣ холӣ ё беэътибор мебошад. Илтимос, ислоҳ кунед.",
      noOperationError: "Илтимос, ақалан як амалиётро илова кунед.",
      operationInvalid: "Илтимос, хатогиҳоро дар амалиёт(ҳо)-и худ ислоҳ кунед."
    }
  },
  // Property names in table headers
  pel: {
    isRequired: "Ҳатмӣ?"
  },
  // Property Editors
  pe: {
    apply: "Сабт",
    ok: "OK",
    save: "Сабт кардан",
    cancel: "Бекор кардан",
    reset: "Партофтан",
    close: "Махкам кардан",
    delete: "Нест кардан",
    add: "Илова кардан",
    Addnew: "Илова кардани нав",
    addItem: "Пахш кунед, барои илова кардани элемент...",
    addOther: "Дигар",
    addSelectAll: "Интихоб кардани ҳамаи нуқтаҳо",
    addNone: "Ҳичӣ",
    removeAll: "Ҳамаро нест кардан",
    edit: "Тағйир додан",
    back: "Бозгашт бе сабт",
    saveAndBack: "Сабт кардан ва бозгаштан",
    itemValueEdit: "Нишон додан, агар",
    editChoices: "Тағйир додани интихоб",
    move: "Ҷойивазкунӣ",
    empty: "<холӣ>",
    notEmpty: "<тағйир додани қиммат>",
    fastEntry: "Даромади тез",
    formEntry: "Формаи даромад",
    testService: "Тести хизматрасонӣ",
    itemSelectorEmpty: "Илтимос, элементро интихоб кунед",
    conditionSelectQuestion: "Саволро интихоб кунед ...",
    conditionSelectPage: "Саҳифаро интихоб кунед ...",
    conditionSelectPanel: "Бастаро интихоб кунед ...",
    conditionValueQuestionTitle: "Илтимос, қимматро ворид/интихоб кунед",
    conditionButtonAdd: "Илова кардан",
    conditionButtonReplace: "Иваз кардан",
    conditionHelp:
      "Илтимос, ифодаи мантиқиро ворид кунед. Бояд қиммати 'true' баргардонад, барои савол/саҳифа нобаён бошад, мисол:.. {Савол1} = 'қиммат1' ё ({Савол2} * {Савол4}> 20 ва {Савол3} <5)",
    expressionHelp:
      "Илтимос, ифодаро ворид кунед. Шумо метавонед қавзҳои ҷингиларо истифода кунед, барои дастрасӣ гирифтан ба қимматҳои савол: '{Савол1} + {Савол2}', '({нарх}*{шумора}) * (100 - {тахфиф}).",
    aceEditorHelp: "Тугмаҳои Ctrl+Пробел пахш кунед, барои гирифтани ишораҳои кӯмакӣ",
    aceEditorRowTitle: "Сатрҳои ҷорӣ",
    aceEditorPanelTitle: "Бастаи ҷорӣ",
    showMore: "Барои гирифтани маълумоти мушаххастар, илтимос, ба дастурамал гузаред",
    conditionShowMoreUrl:
      "Https://surveyjs.io/Documentation/LibraryParameter?id=Question¶meter=visibleIf",
    assistantTitle: "Саволҳои дастрас:",
    cellsEmptyRowsColumns: "Бояд ақалан як сатр ё сутун бошад",

    propertyIsEmpty: "Илтимос, қимматро ворид кунед",
    propertyNameIsNotUnique: "Лутфан як номи беҳамто ворид кунед",
    listIsEmpty: "Ҳолати нав илова кунед",
    expressionIsEmpty: "Ибораи холӣ аст",
    value: "Қиммат",
    text: "Матн",
    rowid: "ID-и сатр",
    imageLink: "Истинод ба сурат",
    columnEdit: "Иваз додани сутун: {0}",
    itemEdit: "Тағйир додани элемент: {0}",

    url: "URL",
    path: "Роҳ",
    valueName: "Номи нуқта",
    titleName: "Сарлавҳаи нуқта",
    titlePlaceholder: "Сарлавҳа ворид кунед",
    surveyTitlePlaceholder: "Сарлавҳаи пурсишро ворид кунед",
    pageTitlePlaceholder: "Сарлавҳаи саҳифаро ворид кунед",
    descriptionPlaceholder: "Тавсифро ворид кунед",
    surveyDescriptionPlaceholder: "Тавсифи пурсишро ворид кунед",
    pageDescriptionPlaceholder: "Тавсифи саҳифаро ворид кунед",

    showOtherItem: "Нуқтаи 'Дигар' вуҷуд аст",
    otherText: "Манти нуқтаи 'Дигар'",
    showNoneItem: "Ягон нуқта вуҷуд надорад",
    noneText: "Матни нуқтаи 'Ҳиҷӣ'",
    hasSelectAll: "Ҳамаи нуқтаҳоро интихоб кардан",
    selectAllText: "Матни нуқта 'Ҳамаи нуқтаҳоро интихоб кардан'",
    choicesMin: "Қиммати минималӣ барои элементҳои сохташуда бо роҳи автоматӣ",
    choicesMax: "Қиммати максималӣ барои элементҳои сохташуда бо роҳи автоматӣ",
    choicesStep: "Фарқият байни элементҳои сохташуда бо роҳи автоматӣ",
    name: "Ном",
    title: "Сарлавҳа",
    cellType: "Намдуи катакча",
    ColCount: "Шумораи сутунҳо",
    choicesOrder: "Интихоб кардани фармоиши интихоб",
    visible: "Нишон додан?",
    isRequired: "Ҳатмӣ?",
    isAllRowRequired: "Ҳамаи сатрҳо барои пуркунӣ ҳатмӣ мебошад",
    requiredErrorText: "Ин майдон баро пуркунӣ ҳатмист",
    startWithNewLine: "Аз сатри нав сар кардан?",
    rows: "Шумораи сатрҳо",
    PlaceHolder: "Ҷойдор",
    showPreview: "Нишон додани пешнамоиш?",
    storeDataAsText: "Нигоҳ доштани дохили файл дар формати JSON ҳамчун матн",
    MaxSize: "Андозаи максималии файл дар байт",
    ImageHeight: "Баландии сурат",
    ImageWidth: "Дарозии сурат",
    rowCount: "Шумораи сатрҳо",
    columnLayout: "Макети сутунҳо",
    addRowLocation: "Илова кардани ҷойи тугмаи сатр",
    addRowText: "Илова кардани матни тугмаи сатр",
    removeRowText: "Нест кардани тугмаи матн",
    rateMin: "Рейтинги минималӣ",
    rateMax: "Рейтинги максималӣ",
    rateStep: "Қадами рейтинг",
    minRateDescription: "Маълумот барои рейтинги минималӣ",
    maxRateDescription: "Маълумот барои рейтинги максималӣ",
    inputType: "Намуди дохилкунӣ",
    optionsCaption: "Танзимотҳои имзо",
    DefaultValue: "Қиммати нобаён",
    cellsDefaultRow: "Матни нобаёни катак",

    surveyEditorTitle: "Танзимоти саволнома",
    qEditorTitle: "Тағйир додани: {0}",

    maxLength: "Шумораи максималӣ",
    buildExpression: "Сохтан",
    editExpression: "Таҳрир кунед",
    and: "ВА",
    or: "Ё",
    remove: "Ҷойивазкунӣ",
    addCondition: "шарт илова кунед",

    //survey
    showTitle: "Нишон/пинҳон кардани сарлавҳа",
    locale: "Забон ба нобаён",
    simulator: "Таҷҳизотро интихоб кунед",
    landscapeOrientation: "Манзаравӣ",
    mode: "Намуд (тағйирот/намоиш)",
    clearInvisibleValues: "Тоза кардани қимматҳои ноёан",
    cookieName: "Номи Cookie (куштани такроран локалӣ гузаштани саволнома)",
    sendResultOnPageNext: "Нишон додани натиҷаи саволнома дар саҳифаи наздик",
    storeOthersAsComment: "Нигоҳ доштани қиммати 'Дигар' дар майдони алоҳида",
    showPageTitles: "Нишон додани сарлавҳаи саҳифа",
    showPageNumbers: "Нишон додани рақами саҳифа",
    pagePrevText: "Матн дар тугмаи 'Саҳифаи пештара'",
    pageNextText: "Матн дар тугмаи 'Саҳифаи оянда'",
    completeText: "Матн дар тугмаи 'Анҷом додан'",
    startSurveyText: "Матн дар тугмаи 'Сар кардан'",
    showNavigationButtons: "Нишон додани тугмаҳои новбарӣ (новбарии нобаён)",
    showPrevButton: "Нишон додани тугмаи 'Саҳифаи пештара' (истифодабар метавонад ба саҳифаи пештара баргардад)",
    firstPageIsStarted: "Саҳифаи якуми саволнома саҳифаи саршаванда мебошад.",
    showCompletedPage: "Нишон додани саҳифа бо матн дар анҷоми пуркунӣ (HTML-и саҳифаи анҷом)",
    goNextPageAutomatic: "Гузариш ба саҳифаи оянда ба роҳи автоматӣ дар ҳолати пуркунии ҳамаи саволҳо",
    showProgressBar: "Нишон додани пешравии пуркунӣ",
    questionTitleLocation: "Ҷойгиршавии сарлавҳаи савол",
    requiredText: "Аломат барои саволи ҳатмӣ",
    questionStartIndex: "Индекси саршавии савол (1, 2 ё 'A', 'а')",
    showQuestionNumbers: "Нишон додани номери савол",
    questionTitleTemplate: "Намунаи номи саволнома, ҳамчун нобаён: {матнро} {талаб} {намекунад}.",
    questionErrorLocation: "Ҷойгиркунии хатогии саволнома",
    focusFirstQuestionAutomatic: "Гузариш ба саволи якум дар ивазкунии саҳифа",
    questionsOrder: "Мураттабсозии элементҳо дар саҳифа",
    maxTimeToFinish: "Вақти максималӣ дар сонияҳо, барои пур кардани саволнома",
    maxTimeToFinishPage: "Вақти максималӣ дар сонияҳо, барои пур кардани саҳифаи саволнома",
    showTimerPanel: "Нишон додани бастаи вақтсанҷ",
    showTimerPanelMode: "Нишон додани ҳолати бастаи таймер",
    RenderMode: "Ҳолати визуализатсия",
    allowAddPanel: "Иҷозат додан ба илова кардани бастаҳо",
    allowRemovePanel: "Иҷозат додан ба нест кардани бастаҳо",
    panelAddText: "Иловаи матн ба баста",
    panelRemoveText: "Нест кардани матн ба баста",
    isSinglePage: "Нишон додани ҳамаи элементҳо дар як саҳифа",
    HTML: "HTML",
    expression: "Ифода",

    minValue: "Қиммати минималӣ",
    maxValue: "Қиммати максималӣ",
    mINLENGTH: "Дарозии минималӣ",
    allowDigits: "Иҷозат додани рақамҳо",
    minCount: "Шумораи минималӣ",
    maxCount: "Шумораи максималӣ",
    regex: "Ифодаи регулярӣ",

    totalText: "Тексти умумӣ",
    totalType: "Намуди умумӣ",
    totalExpression: "Ифодаи умумӣ",
    totalDisplayStyle: "Услуби намоиши умумӣ",
    totalCurrency: "Асъори умумӣ",
    totalFormat: "Намуди умумӣ",
    // Header  adorner
    logoPosition: "Ҷойгиршавии логотип",
    addLogo: "Иловаи логотип...",
    changeLogo: "Тағйир додани логотип...",
    logoPositions: {
      none: "Разместить логотип",
      left: "Аз чап",
      right: "Дар тарафи рост",
      top: "Аз боло",
      bottom: "Аз поён"
    },

    tabs: {
      general: "Умумӣ",
      fileOptions: "Танзимотҳо",
      HTML: "Ивазкунаки HTML",
      columns: "Сутунҳо",
      rows: "Сатрҳо",
      choices: "Интихоб",
      items: "Элементҳо",
      visibleIf: "Нишон додан, агар",
      enableIf: "Дастрас аст, агар",
      requiredIf: "Ҳатмӣ барои пуркунӣ, агар",
      rateValues: "Баҳодиҳии қимматбаҳои савол",
      choicesByUrl: "Интихоб аз интернет",
      matrixChoices: "Интихоби нобаён",
      multipleTextItems: "Дохилкунии якчанд майдончаҳои матнӣ",
      validators: "Валидаторҳо",
      navigation: "Новбарӣ",
      question: "Савол",
      completedHtml: "HTML-и саҳифаи натиҷавӣ",
      completedHtmlOnCondition: "HTML-и саҳифаи натиҷавӣ дар шарти",
      loadingHtml: "Боркунии HTML",
      timer: "Вақтсанҷ/Викторина",
      calculatedValues: "Қимматҳои ҳисобкунӣ",
      triggers: "Триггерҳо",
      templateTitle: "Номи намуна",
      totals: "Натиҷаҳо",
      logic: "Мантиқ",
      layout: "Тарҳ",
      data: "Маълумот",
      validation: "Санҷед",
      cells: "Ҳуҷайраҳо",
      showOnCompleted: "Дар охир нишон диҳед",
      logo: "Логитип дар сарлавҳаи саволнома",
      others: "Дигар"
    },
    editProperty: "Тағйири хосияти '{0}'",
    items: "[Элементҳо: {0}]",

    enterNewValue: "Илтимос, қимматро ворид кунед.",
    noquestions: "Дар саволнома ягон савол нест",
    createtrigger: "Илтимос, триггерро созед",
    triggerOn: "О",
    triggerMakePagesVisible: "Саҳифаҳоро намоён кардан:",
    triggerMakeQuestionsVisible: "Элементҳоро номаён кардан:",
    triggerCompleteText: "Тамом кардани саволнома, агар ҳама иҷро шавад.",
    triggerNotSet: "Триггер сабт нашудааст.",
    triggerRunIf: "Сар кардан, агар",
    triggerSetToName: "Тағйири қиммат:",
    triggerFromName: "Нусхабардорӣ кардани қиммат аз:",
    triggerRunExpression: "Иҷро кардани ин ифода:",
    triggerSetValue: "ба:",
    triggerGotoName: "Гузариш ба савол:",
    triggerIsVariable: "Тағйирёбандаро ба натиҷаи саволнома нагузоштан.",
    triggerRunExpressionEmpty: "Илтимос, қиммати дурустро ворид кунед."
  },
  // Property values
  pv: {
    true: "true",
    false: "false",
    inherit: "Меросгирӣ кардан",
    show: "Нишон додан",
    hide: "Пинҳон кардан",
    default: "Нобаёнӣ",
    initial: "Тартиботи аввала",
    random: "Тартиботи тасодуфӣ",
    collapsed: "Қатъ шуд",
    expanded: "Зиёд шуд",
    none: "Не",
    asc: "Ба калоншавӣ",
    desc: "Ба камшавӣ",
    indeterminate: "Номуайян",
    decimal: "Даҳӣ",
    currency: "Асъор",
    percent: "Фоизҳо",
    firstExpanded: "Якум зиёд шудааст",
    off: "Куштан",
    onPanel: "Дар баста",
    onSurvey: "Дар саволнома",
    list: "Рӯйхат",
    progressTop: "progressTop",
    progressBottom: "progressBottom",
    progressTopBottom: "progressTopBottom",
    horizontal: "Уфуқӣ",
    vertical: "Амудӣ",
    top: "Аз боло",
    bottom: "Аз поён",
    topBottom: "Аз боло ва поён",
    left: "Чап",
    color: "Ранг",
    date: "Сана",
    datetime: "Сана ва вақт",
    "datetime-local": "Сана ва вақти маҳаллӣ",
    email: "Email",
    month: "Моҳ",
    number: "Рақам",
    password: "Рамз",
    range: "Диапазон",
    tel: "Телефон",
    text: "Матн",
    time: "Вақт",
    url: "URL",
    week: "Ҳафта",
    hidden: "Пинҳон",
    on: "Гирондан",
    onPage: "Дар саҳифа",
    edit: "Тағйир додан",
    display: "Намоиш",
    onComplete: "Пас аз анҷом",
    onHidden: "Пас аз пинҳон",
    all: "Ҳама",
    page: "Саҳифа",
    survey: "Саволнома",
    onNextPage: "Дар гузариш ба саҳифаи оянда",
    onValueChanged: "Дар тағйири қиммат"
  },
  // Operators
  op: {
    empty: "пур накарда",
    notempty: "пур карда",
    equal: "баробар",
    notequal: "нобаробар",
    contains: "дар бар дорад",
    notcontains: "дар бар надорад",
    anyof: "ҳар як аз",
    allof: "ҳама аз",
    greater: "зиёдтар",
    less: "камтар",
    greaterorequal: "калон ё баробар",
    lessorequal: "кам ё баробар"
  },
  // Embed window
  ew: {
    angular: "Истифода баред версияи Angular",
    jquery: "Истифода баред версияи jQuery",
    knockout: "Истифода баред версияи Knockout",
    react: "Истифода баред версияи React",
    vue: "Истифода баред версияи Vue",
    bootstrap: "Барои китобхонаи bootstrap",
    standard: "Бе китобхонаи bootstrap",
    showOnPage: "Нишон додани саволнома дар саҳифа",
    showInWindow: "Нишон додани саволнома дар равзанаи модалӣ",
    loadFromServer: "Бор кардани Json саволнома аз сервер",
    titleScript: "Скриптҳо и услубҳо",
    titleHtml: "HTML",
    titleJavaScript: "JavaScript"
  },
  // Опрос Тест
  ts: {
    selectPage: "Саҳифаро интихоб кунед, барои санҷидани ин:",
    showInvisibleElements: "Нишон додани элементҳои пинҳон"
  },
  validators: {
    answercountvalidator: "Шумораи ҷавобҳо",
    EmailValidator: "Email",
    expressionvalidator: "Ишора",
    numericvalidator: "Рақам",
    regexvalidator: "Ишораи регулярӣ",
    textvalidator: "Матн"
  },
  triggers: {
    completetrigger: "Анҷом додани саволнома",
    setvaluetrigger: "Гузоштани қиммат",
    copyvaluetrigger: "Нусхабардорӣ кардани қиммат",
    skiptrigger: "Гузариш ба саволи",
    runexpressiontrigger: "Иҷро кардани ишора",
    visibletrigger: "Тағйир кардани намоиш (тавсия дода намешавад)"
  },
  // Properties
  p: {
    name: "Ном",
    title: {
      name: "Ном",
      title: "Холӣ гузоред, агар номи ӯ ҳамчун 'Ном' бошад"
    },
    navigationButtonsVisibility: "Нишон додани тугмаҳои новбарӣ",
    questionsOrder: "Мураттабсозии элементҳо дар саҳифа",
    maxTimeToFinish: "Вақти максималӣ барои анҷом додан",

    visible: "Аён аст",
    visibleIf: "Нишон додан, агар",
    questionTitleLocation: "Ҷойгиршавии сарлавҳаи савол",
    description: "Шарҳ",
    state: "Ҳолат",
    isRequired: "Ҳатмӣ",
    requiredIf: "Ҳатмист, агар",
    indent: "Нишон",
    requiredErrorText: "Ин майдон барои пуркунӣ ҳатмист",
    startWithNewLine: "Аз сатри нав сар кардан",
    innerIndent: "Нишони дарунӣ",
    page: "Саҳифа",

    width: "Дарозӣ",

    commentText: "Шарҳ",
    valueName: "Номи қиммат",
    enableIf: "Дастрас аст дар шарти",
    defaultValue: "Қиммат бо нобаён",
    correctAnswer: "Ҷавоби дуруст",
    readOnly: "Танҳо барои хониш",
    validators: "Валидаторҳо",
    titleLocation: "Ҷойгиршавии сарлавҳа",

    hasComment: "Шарҳ вуҷуд аст",
    showOtherItem: "Қиммати 'Дигар' вуҷуд аст",
    choices: "Интихоб",
    choicesOrder: "Интихоби фармоиши интихоб",
    choicesByUrl: "Интихоб аз интернет",
    otherText: "Элементи матнии дигар",
    otherErrorText: "Матни хатогии майдони 'Дигар'",
    storeOthersAsComment: "Нигоҳ доштани майдони 'Дигар', ҳамчун шарҳ",

    label: "Миёнабур",
    showTitle: "Нишон додани ном",
    valueTrue: "Дуруст",
    valueFalse: "Нодуруст",

    cols: "Сутунҳо",
    rows: "Сатрҳо",
    placeholder: "Ҷойдор",

    optionsCaption: "Танзимотҳои имзо",

    expression: "Ишора",
    format: "Намуд",
    displayStyle: "Услуби намоиш",
    currency: "Асъор",
    useGrouping: "Истифодаи гуруҳбандӣ",

    showPreview: "Нишон додани пешнамоиш",
    allowMultiple: "Интихоби якчанд",
    imageHeight: "Баландии сурат",
    imageWidth: "Дарозии сурат",
    storeDataAsText: "Нигоҳ доштани қиммат ҳамчун матн",
    maxSize: "Андозаи максималӣ",

    html: "HTML",

    columns: "Сутунҳо",
    cells: "Майдонҳо",
    isAllRowRequired: "Ҳамаи сатрҳо ҳатмист барои пуркунӣ",

    horizontalScroll: "Скролли уфуқӣ",
    cellType: "Намуди майдонча",
    columnsLayout: "Макети сутунҳо",
    columnColCount: "Шумораи сутунҳо",
    columnMinWidth: "Дарозии минималии сутун",

    rowCount: "Шумораи сатрҳо",
    minRowCount: "Шумораи минималии сатрҳо",
    maxRowCount: "Шумораи максималии сатрҳо",
    keyName: "Номи калид",
    keyDuplicationError: "Хатогӣ! Ин калид аллакай вуҷуд дорад, номи дигарро ишора кунед.",
    confirmDelete: "Несткуниро тасдиқ кунед",
    confirmDeleteText: "Матни хат барои тасдиқи несткунӣ",
    addRowLocation: "Илова кардани ҷойгиршавии сутунҳо",
    addRowText: "Илова кардани тугмаи сатри матн",
    removeRowText: "Нест кардани тугмаи сатри матн",

    items: "Элементҳо",
    itemSize: "Андозаи элементҳо",
    colCount: "Шумораи сутунҳо",

    templateTitle: "Сарлавҳаи намуна",
    templateDescription: "Шарҳи намуна",
    allowAddPanel: "Иҷозат додани илова кардани баста",
    allowRemovePanel: "Иҷозат додани нест кардани баста",
    panelCount: "Шумораи бастаҳо",
    minPanelCount: "Шумораи минималии бастаҳо",
    maxPanelCount: "Шумораи максималии бастаҳо",
    panelsState: "Ҳолати бастаҳо",
    panelAddText: "Матни хат дар иловакунии баста",
    panelRemoveText: "Матни хат дар несткунии баста",
    panelPrevText: "Матни хати бастаи пештара",
    panelNextText: "Матни хати бастаи оянда",
    showQuestionNumbers: "Нишон додани рақами саволҳо",
    showRangeInProgress: "Нишон додани пешравии пуркунӣ",
    renderMode: "Намуди аён",
    templateTitleLocation: "Ҷойгиршавии сарлавҳаи намуна",

    rateValues: "Баҳодиҳии қимматбаҳоии саволнома",
    rateMin: "Рейтинги минималӣ",
    rateMax: "Рейтинги максималӣ",
    rateStep: "Қадами рейтинг",
    minRateDescription: "Шарҳ барои рейтинги минималӣ",
    maxRateDescription: "Шарҳ барои рейтинги максималӣ",

    inputType: "Намуди дохилкунӣ",
    size: "Андоза",

    locale: "Равия",
    focusFirstQuestionAutomatic: "Гузариш ба саволи якум пас аз тағйир додани саҳифа",
    completedHtml: "HTML-и саҳифаи охирон",
    completedHtmlOnCondition: "HTML-и саҳифаи охирон дар шарти",
    loadingHtml: "Боркунии HTML",
    triggers: "триггерҳо",
    cookieName: "номи Cookie",
    sendResultOnPageNext: "Нишон додани натиҷаи саволнома дар саҳифаи наздик",
    showNavigationButtons: "Нишон додани тугмаҳои новбарӣ (новбарии нобаён)",
    showPrevButton: "Нишон додани тугмаи 'Саҳифаи пештара' (истифодабар метавонад гузаштан ба саҳифаи пештара)",
    showPageTitles: "Нишон додани номи саҳифа",
    showCompletedPage: "Нишон додани саҳифа бо матн дар анҷом (HTML-и саҳифаи натиҷавӣ)",
    showPageNumbers: "Нишон додани рақамҳои саҳифа",
    questionErrorLocation: "Гузориши хатогиҳои саволнома",
    showProgressBar: "Нишон додани пешравии пуркунӣ",
    mode: "Намуд",
    goNextPageAutomatic: "Гузариш бо роҳи автоматӣ ба саҳаифаи оянда дар ҳолати ҷавоб додан ба ҳамаи саволҳо",
    checkErrorsMode: "Намуди санҷиши хатогиҳо",
    clearInvisibleValues: "Тоза кардани қимматҳои ноаён",
    startSurveyText: "Матн дар тугмаи 'Сар кардан'",
    pagePrevText: "Матн дар тугмаи 'Саҳифаи пештара'",
    pageNextText: "Матн дар тугмаи 'Саҳифаи оянда'",
    completeText: "Матн дар тугмаи 'Тамом кардан'",
    requiredText: "Аломат барои саволи ҳатмӣ",
    questionStartIndex: "Индекси саршаванда дар саволнома (1, 2 ё 'A', 'а')",
    questionTitleTemplate: "Намунаи номи саволнома, ҳамчун нобаён: {матнро} {талаб} {намекунад}.",
    firstPageIsStarted: "Якум саҳифаи саволнома саҳифаи саршаванда мебошад.",
    isSinglePage: "Нишон додани ҳамаи элементҳо дар як саҳифа",
    maxTimeToFinishPage: "Вақти максималӣ дар сонияҳо, барои пур кардани саҳифаи саволнома",
    showTimerPanel: "Нишон додани бастаи вақтсанҷ",
    showTimerPanelMode: "Нишон додани намуди бастаи вақтсанҷ",

    defaultPanelValue: "Қимматҳои бастаи нобаён",
    defaultRowValue: "Қимматҳои сатри нобаён",
    showNoneItem: "Ягон нуқта нест",
    noneText: "Матни нуқтаи 'Ҳеҷ чиз'",

    text: "Матн"
  }
};

editorLocalization.locales["tg"] = tgStrings;